import { RenderInstruction } from "aurelia-validation";
import * as DOMPurify from "dompurify";

export class RightshipOnboardingValidationRenderer {

    render(instruction: RenderInstruction) {
        if (instruction.unrender.length > 0 || instruction.kind == "reset") {
            const validatedElement = document.querySelectorAll('.error-validation');
            for (let index = 0; index < validatedElement.length; index++) {
                const el = validatedElement[index];
                el.classList.remove('error-validation');
            }
        }
        for (const { result, elements } of instruction.render) {
            if (!result.valid) {
                for (const element of elements) {
                    this.displayErrorMessage(element, result.message);
                }
            }
            else
            {
                //if valid clear error message on qustion
                for (const element of elements) {
                    const questionWrap = this.findAncestor(element as HTMLElement, 'question-wrap');
                    this.hideErrorMessage(questionWrap, element);
                }
            }
        }
    }

    private displayErrorMessage(element: Element, error: string) {

        const questionWrap = this.findAncestor(element as HTMLElement, 'question-wrap');

        this.hideErrorMessage(questionWrap, element);

        const pageElement = this.findAncestor(questionWrap as HTMLElement, 'page');

        const label = $(questionWrap).find(".error-message").get(0);
        if (label) {
            label.innerHTML = DOMPurify.sanitize(error);
        }

        element.classList.add('error-validation');
        if (element.tagName == "TEXT-BOX") {
            const func = () => {
                this.hideErrorMessage(questionWrap, element);
                element.removeEventListener('textchange', func);
                this.checkIfPageIsValid(pageElement);
            };
            element.addEventListener('textchange', func);
        }
        if (element.tagName == "CHECK-BOX") {
            const func = () => {
                this.hideErrorMessage(questionWrap, element);
                element.removeEventListener('changed', func);
                this.checkIfPageIsValid(pageElement);
            };
            element.addEventListener('changed', func);
        }
        if (element.tagName == "YES-NO-CONTROL") {
            const func = () => {
                this.hideErrorMessage(questionWrap, element);
                element.removeEventListener('changed', func);
                this.checkIfPageIsValid(pageElement);
            };
            element.addEventListener('changed', func);
        }
        $(element)
            .find("input, textarea")
            .one("focus", () => {
                this.hideErrorMessage(questionWrap, element);
                this.checkIfPageIsValid(pageElement);
            });
        $(element)
            .find("input, textarea")
            .one("change", () => {
                this.hideErrorMessage(questionWrap, element);
                this.checkIfPageIsValid(pageElement);
            });
        $(element)
            .find('.lookup-item-wrap, .lookup-item, form-lookup-control')
            .one("click", () => {
                this.hideErrorMessage(questionWrap, element);
                this.checkIfPageIsValid(pageElement);
            });
        this.checkIfPageIsValid(pageElement);
    }

    private hideErrorMessage(wrapper: Element, element: Element) {
        const label = $(wrapper).find(".error-message").get(0);
        if (label) {
            label.innerHTML = null;
        }
        element.classList.remove('error-validation');
    }

    checkIfPageIsValid(page: HTMLElement) {
        if (!page) {
            return;
        }
        page.classList.remove('invalid-page')
        if (page.querySelectorAll('.error-validation').length > 0) {
            page.classList.add('invalid-page')
        }
    }

    findAncestor(el: HTMLElement, cls) {
        if (!el) {
            return document.querySelector('.' + cls) as HTMLElement;
        }
        el = el.parentElement;
        while (el) {
            if (el.classList.contains(cls)) {
                return el;
            }
            const collection = ([].slice.call(el.children) as HTMLElement[]);
            const elements = collection.filter(x => x.classList.contains(cls));
            if (elements.length > 0 && elements[0]) {
                return elements[0];
            }
            el = el.parentElement;
        }
        return el || (document.querySelector('.' + cls) as HTMLElement);
    }
}
